






























































































































































import { XPorterSchoolModel } from '@/types';
import { XPorterConfigurationService } from '@/services/XPorterConfigurationService';
import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import { ValidationModel } from '@/types/models/validation';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ModalHelpers } from '@/mixins';

export default Vue.extend({
  name: 'XPorterConfiguration',
  props: {},
  data() {
    return {
      isLoading: true,
      schools: [] as XPorterSchoolModel[],
      isSubmitting: false,
      schoolBeingEdited: {} as XPorterSchoolModel,
      schoolToAdd: {} as XPorterSchoolModel,
      schoolIsBeingAdded: false
    };
  },
  computed: {
    isSchoolBeingEdited(this: any) {
      return Boolean(Object.keys(this.schoolBeingEdited).length);
    },
    isSchoolBeingAdded(this: any) {
      return Boolean(Object.keys(this.schoolToAdd).length);
    }
  },
  methods: {
    editSchool(index: number) {
      this.schoolBeingEdited = { ...this.schools[index] };
    },
    async saveSchool() {
      this.isSubmitting = true;
      try {
        const updatedSchools = await XPorterConfigurationService.updateSchool(this.schoolBeingEdited);
        SnotifyConfiguration.showSuccess('School successfully updated');
        this.schools = updatedSchools;
        this.schoolBeingEdited = {} as XPorterSchoolModel;
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    cancelEditSchool() {
      this.schoolBeingEdited = {} as XPorterSchoolModel;
    },
    async deleteSchool(schoolId: number) {
      this.isSubmitting = true;
      if (!(await ModalHelpers.methods.showConfirmationModalAsync(this.$bvModal, 'Are you sure you want to delete the school?'))) {
        this.isSubmitting = false;
        return;
      }

      try {
        const updatedSchools = await XPorterConfigurationService.deleteSchool(schoolId);
        SnotifyConfiguration.showSuccess('School successfully deleted');
        this.schools = updatedSchools;
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    updateSchoolName(id: number, value: string) {
      if (this.schoolBeingEdited.id !== id) {
        return;
      }
      Vue.set(this.schoolBeingEdited, 'schoolName', value);
    },
    updateSecret(id: number, value: string) {
      if (this.schoolBeingEdited.id !== id) {
        return;
      }
      Vue.set(this.schoolBeingEdited, 'secret', value);
    },
    updateSchoolToAddId(value: string) {
      Vue.set(this.schoolToAdd, 'id', Number(value));
    },
    updateSchoolToAddName(value: string) {
      Vue.set(this.schoolToAdd, 'schoolName', value);
    },
    updateSchoolToAddSecret(value: string) {
      Vue.set(this.schoolToAdd, 'secret', value);
    },
    async addSchool() {
      const isValid = await (this.$refs.addSchoolValidationObserver as any).validate();
      if (!isValid) {
        return;
      }

      this.isSubmitting = true;
      try {
        const updatedSchools = await XPorterConfigurationService.addSchool(this.schoolToAdd);
        SnotifyConfiguration.showSuccess('School successfully added');
        this.schools = updatedSchools;
        this.schoolToAdd = {} as XPorterSchoolModel;
        this.isSubmitting = false;
        await (this.$refs.addSchoolValidationObserver as any).reset();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async cancelAddSchool() {
      this.schoolToAdd = {} as XPorterSchoolModel;
      await (this.$refs.addSchoolValidationObserver as any).reset();
    },
    initialiseSchoolToAdd() {
      if (!this.isSchoolBeingAdded) {
        this.schoolToAdd = {
          schoolName: '',
          secret: ''
        } as XPorterSchoolModel;
      }
    },
    async testSchool(schoolId: number) {
      const school = this.schools.find((x) => x.id === schoolId);
      this.isSubmitting = true;
      try {
        await XPorterConfigurationService.testSchool(schoolId);
        SnotifyConfiguration.showSuccess('Successfully authenticated for ' + school?.schoolName);
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.schools = await XPorterConfigurationService.getSchools();
    this.isLoading = false;
  },
  created(this: any) {
    this.SCHOOL_ID_VALIDATION = { required: true, minValue: 0, maxValue: 1000000000 } as ValidationModel;
    this.SCHOOL_NAME_VALIDATION = { required: true } as ValidationModel;
    this.SECRET_VALIDATION = { required: true } as ValidationModel;
  },
  components: { LoadingSpinner, MStoreSpinnerButton, MStoreForm, MStoreFormInput }
});
